import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import {
  UpdatePokemonNameInput,
  UpdatePokemonNameOutput,
  WebAppRoutes,
} from "types/web-app";

export const updatePokemonName = async (
  accessToken: string,
  input: UpdatePokemonNameInput,
): Promise<{ ok: boolean; message?: string }> => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.UPDATE_POKEMON_NAME,
      accessToken,
      {
        method: "POST",
        body: JSON.stringify(input),
      },
    );

    const result =
      (await response.json()) as ServiceResponse<UpdatePokemonNameOutput>;

    if (!response.ok || !result.ok) {
      return {
        ok: false,
        message: result.message || "Failed to update Pokemon name",
      };
    }

    return { ok: true };
  } catch (error) {
    console.error("Error updating Pokemon name:", error);
    return {
      ok: false,
      message: "Network error while updating Pokemon name",
    };
  }
};
